"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var helpers_1 = require("../../mock/helpers");
function setAlgorandResources(account) {
    var _a, _b;
    /** format algorandResources given the new delegations */
    account.algorandResources = {
        rewards: account.balance.multipliedBy(0.01),
        nbAssets: (_b = (_a = account.subAccounts) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0
    };
    return account;
}
function genBaseOperation(account, rng, type, index) {
    var ops = account.operations;
    var address = (0, helpers_1.genAddress)(account.currency, rng);
    var lastOp = ops[index];
    var date = new Date((lastOp ? lastOp.date.valueOf() : Date.now()) -
        rng.nextInt(0, 100000000 * rng.next() * rng.next()));
    var hash = (0, helpers_1.genHex)(64, rng);
    /** generate given operation */
    return {
        id: String("mock_op_".concat(ops.length, "_").concat(type, "_").concat(account.id)),
        hash: hash,
        type: type,
        value: new bignumber_js_1.BigNumber(0),
        fee: new bignumber_js_1.BigNumber(0),
        senders: [address],
        recipients: [address],
        blockHash: (0, helpers_1.genHex)(64, rng),
        blockHeight: account.blockHeight -
            // FIXME: always the same, valueOf for arithmetics operation on date in typescript
            Math.floor((Date.now().valueOf() - date.valueOf()) / 900000),
        accountId: account.id,
        date: date,
        extra: {
            rewards: new bignumber_js_1.BigNumber(0),
            memo: "memo"
        }
    };
}
function addOptIn(account, rng) {
    /** select position on the operation stack where we will insert the new claim rewards */
    var opIndex = rng.next(0, 10);
    var opt = genBaseOperation(account, rng, "OPT_IN", opIndex);
    opt.extra = __assign(__assign({}, opt.extra), { rewards: new bignumber_js_1.BigNumber(0), assetId: "Thether" });
    account.operations.splice(opIndex, 0, opt);
    account.operationsCount++;
    return account;
}
function addOptOut(account, rng) {
    /** select position on the operation stack where we will insert the new claim rewards */
    var opIndex = rng.next(0, 10);
    var opt = genBaseOperation(account, rng, "OPT_OUT", opIndex);
    opt.extra = __assign(__assign({}, opt.extra), { rewards: new bignumber_js_1.BigNumber(0), assetId: "Thether" });
    account.operations.splice(opIndex, 0, opt);
    account.operationsCount++;
    return account;
}
/**
 * add in specific algorand operations
 * @memberof algorand/mock
 * @param {Account} account
 * @param {Prando} rng
 */
function genAccountEnhanceOperations(account, rng) {
    addOptIn(account, rng);
    addOptOut(account, rng);
    setAlgorandResources(account);
    return account;
}
/**
 * Update spendable balance for the account based on delegation data
 * @memberof algorand/mock
 * @param {Account} account
 */
function postSyncAccount(account) {
    var algorandResources = account.algorandResources || { rewards: undefined };
    var rewards = algorandResources.rewards || new bignumber_js_1.BigNumber(0);
    account.spendableBalance = account.balance.plus(rewards);
    return account;
}
/**
 * post account scan data logic
 * clears account algorand resources if supposed to be empty
 * @memberof algorand/mock
 * @param {Account} account
 */
function postScanAccount(account, _a) {
    var _b, _c;
    var isEmpty = _a.isEmpty;
    if (isEmpty) {
        account.algorandResources = {
            rewards: new bignumber_js_1.BigNumber(0),
            nbAssets: (_c = (_b = account.subAccounts) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0
        };
        account.operations = [];
        account.subAccounts = [];
    }
    return account;
}
exports["default"] = {
    genAccountEnhanceOperations: genAccountEnhanceOperations,
    postSyncAccount: postSyncAccount,
    postScanAccount: postScanAccount
};
//# sourceMappingURL=mock.js.map